import { render, staticRenderFns } from "./LwfBadgeBool.vue?vue&type=template&id=29d86a7c&scoped=true&"
import script from "./LwfBadgeBool.vue?vue&type=script&lang=js&"
export * from "./LwfBadgeBool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d86a7c",
  null
  
)

export default component.exports